import { ChangeDetectorRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { I18n } from 'src/app/i18n.service';
import { RoutineInfo } from '../routine-info.model';
import { RoutineLevel } from '../routine-level.model';
import { HomeUiService } from '../../new-design/home-ui.service';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
  animations: [
    trigger('animateContent', [
      transition(':enter', [
        query(':scope > *', [
          style({ opacity: 0, transform: 'translateY(8px)' })
        ], { optional: true }),

        query(':scope > *', [
          stagger(100, [
            animate(
              '800ms cubic-bezier(0.76, 0, 0.24, 1)',
              style({ opacity: 1, transform: 'translateY(0)' })
            )
          ])
        ], { optional: true })
      ]),

      transition(':leave', [
        animate(
          '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
          style({ opacity: 0, transform: 'translateY(-75px)' })
        )
      ])
    ])
  ]
})
export class LocationComponent implements OnInit {

  @Input() routine: RoutineInfo
  @Input() level: RoutineLevel
  @Input() inverted = false
  @Input() progressItems = [];
  @Input() currentIndex = 0;
  @Input() screenId: any;

  @Output() locationData = new EventEmitter<any>();
  location: string
  locationLabel: string

  constructor(private i18n: I18n,
    public homeUIService: HomeUiService,
    private cdRef: ChangeDetectorRef,) {
    this.locationLabel = this.i18n.t('at/in location')
   }

  ngOnInit() {
    
  }
  toggleTheme() {
    this.homeUIService.toggleTheme();
    this.cdRef.detectChanges(); 
  }
  getValue(location){
    this.locationData.emit(location.toLowerCase())
  }

}
